import React from "react";

const PowerGridIcon = ({ size = 12, className = "text-green" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          fill="currentColor"
          d="M3.8.4h-1a.4.4 0 0 0-.4.4v.4h-.8a.4.4 0 0 0-.4.4v.8a.4.4 0 0 0 .4.4h1.62c.073.442.414 1.536 1.98 2.511V8h-.4a.6.6 0 0 0-.6.6v2a.6.6 0 0 0 .6.6h.4v.4a.4.4 0 0 0 .4.4h.8a.4.4 0 0 0 .4-.4V5.311C8.366 4.336 8.706 3.242 8.78 2.8h1.62a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4h-.8V.8a.4.4 0 0 0-.4-.4h-1a.4.4 0 0 0-.4.4v.4h-1V.4a.4.4 0 0 0-.4-.4h-.8a.4.4 0 0 0-.4.4v.8h-1V.8a.4.4 0 0 0-.4-.4m-1 .4h1v.4h-1zm.827 2H5.2v2.034C4.004 4.02 3.702 3.176 3.627 2.8m1.173 8a.2.2 0 0 1-.2-.2v-2a.2.2 0 0 1 .2-.2h.4v2.4zm2-5.966V2.8h1.572c-.077.375-.382 1.222-1.572 2.034M8.2.8h1v.4h-1zm-2.8.8a.2.2 0 0 0 .2-.2v-1h.8v1a.2.2 0 0 0 .2.2h3.8v.8H6.6a.2.2 0 0 0-.2.2v9h-.8v-9a.2.2 0 0 0-.2-.2H1.6v-.8z"
        />
        <path
          fill="currentColor"
          d="M5.4 1.6a.2.2 0 0 0 .2-.2v-1h.8v1a.2.2 0 0 0 .2.2h3.8v.8H6.6a.2.2 0 0 0-.2.2v9h-.8v-9a.2.2 0 0 0-.2-.2H1.6v-.8z"
        />
      </svg>
    </span>
  );
};

export default PowerGridIcon;
